<template>
  <div class="starWrap">
    <el-rate
      ref="starWrap"
      v-model="value"
      :disabled="disabled"
      :icon-classes="[
        'iconfont icon-cm-jingdiananli_wujiaoxing_shoucanghou',
        'iconfont icon-cm-jingdiananli_wujiaoxing_shoucanghou',
        'iconfont icon-cm-jingdiananli_wujiaoxing_shoucanghou',
      ]"
      void-icon-class="iconfont icon-cm-jingdiananli_kongwujiaoxing_shoucang"
      disabled-void-icon-class="iconfont icon-cm-jingdiananli_kongwujiaoxing_shoucang"
      void-color="#ffc124"
      disabled-void-color="#ffc124"
      :max="5"
    ></el-rate>
  </div>
</template>
<script>
export default {
  props: ['disabled', 'average_rating', 'font_size'],
  data() {
    return {
      value: 5,
    }
  },
  beforeMount() {
    this.value = this.average_rating - 0
  },
  mounted() {
    this.$('.el-rate__item .el-rate__decimal')
      .parent()
      .removeClass('el-icon-star-on')
      .addClass('iconfont icon-cm-jingdiananli_kongwujiaoxing_shoucang')
    if (this.font_size) {
      this.$(this.$refs.starWrap.$el.children)
        .children('span i')
        .css('font-size', this.font_size + 'px')
    }
  },
  watch: {
    average_rating(val) {
      this.value = val - 0
    },
  },
}
</script>
<style  lang='scss'>
.starWrap {
  display: inline-block;
  .el-rate {
    white-space: nowrap;
    .el-rate__item {
      padding-left: 0 !important;
      margin-right: -2px !important;
      margin-left: -1px !important;
      .el-rate__icon {
        font-size: 22px;
        margin-right: 0 !important ;
        & > i {
          font-size: inherit;
        }
      }
    }
  }
}
</style>
